<template>
	<div class="filelibrarydetail">
		<headerview :cur="2" v-show="type == '4' || type == '5' || type == '6'"></headerview>
		<headerview :cur="4" v-show="type == '1' || type == '2'"></headerview>
		<headerview :cur="5" v-show="type == '3'"></headerview>
		<div class="content">
			
			<div class="moddlecon w13">
				<div class="tipcon">
					
					<tipconNav v-show="type == '1'" :title="'文件库'" :name="[{label:'文件库',url:'/filelibrary'},{label:'详情',url:''}]" :imgtype="'2'" width="1.73"></tipconNav>
					<tipcon v-show="type == '2'" :title="'标准队课'" :name="'标准队课>详情'" :imgtype="'2'" width="2.03"></tipcon>
					<tipcon v-show="type == '3'" :title="'社会情报站'" :name="'红领巾通讯社>社会情报站'" :imgtype="'3'" width="2.6"></tipcon>
					
					
					<tipconNav v-show="type == '4'" :title="'重要资讯'" :name="[{label:'重要资讯',url:'/teaminform?type='+$route.query.type},{label:'详情',url:''}]" :imgtype="'2'" width="2"></tipconNav>
					<tipconNav v-show="type == '5'" :title="'最新通知'" :name="[{label:'最新通知',url:'/teaminform?type='+$route.query.type},{label:'详情',url:''}]" :imgtype="'2'" width="2"></tipconNav>
					<tipconNav v-show="type == '6'" :title="'各地动态'" :name="[{label:'各地动态',url:'/teaminform?type='+$route.query.type},{label:'详情',url:''}]" :imgtype="'2'" width="2"></tipconNav>
				</div>

				<div class="min-h">
					<textdetails :informdata="informdata"></textdetails>
				</div>
				
			</div>	
		</div>
		
		<footview></footview>
		
	</div>
	
</template>

<script>

import tipcon from "../../../com/tipcon.vue";
import textdetails from "../../../com/textdetails.vue";

export default {
  components: {
  	  tipcon,
	  textdetails,
  },
  data: function() {
    return {
		type:'1',
		informdata:{
			title:"标题名称标题名称标题名称",
			source:"来源来着",
			datetime:"2021-01-01 13:12:00",
			contentval:"文本内容文本内容文本内容文本内容文本内容"
		},
		id:"",
	  
    };
  },
  
  mounted() {
		this.$onScrollT()
		if(this.$route.query) {
			this.type = this.$route.query.type;
			this.id = this.$route.query.id;
		}
		
		if(this.type == '1' || this.type == '2'){
			this.getCulturalDetail()
		}else if(this.type == '3'){
			this.getHeadlinesDetail()
		}else if(this.type == '4' || this.type == '5' || this.type == '6'){
			this.getTeamSituation()
		}
  },

  methods: {
	    //文件库
	    getCulturalDetail(){
	    	this.$get(`web/culturalproduct/queryDataById?id=${this.id}`).then(res=>{
	    		  if(res.success){
	    				this.informdata.title = res.result.title
	    				this.informdata.source = res.result.source
	    				this.informdata.datetime = res.result.createTime
	    				this.informdata.contentval = res.result.content		
	    		  }
	    	})
	    },
		
	    //社会情报站
		getHeadlinesDetail(){
			this.$get(`web/info/queryById?id=${this.id}`).then(res=>{
				  if(res.success){
						this.informdata.title = res.result.title
						this.informdata.source = res.result.source
						this.informdata.datetime = res.result.pubTime
						this.informdata.contentval = res.result.hypertext		
				  }
			})
		},
		
		//队情资讯
		getTeamSituation(){
			this.$get(`web/teamSituation/queryById?id=${this.id}`).then(res=>{
				  if(res.success){
						this.informdata.title = res.result.title
						this.informdata.source = res.result.source
						this.informdata.datetime = res.result.pubTime
						this.informdata.contentval = res.result.hypertext		
				  }
			})
		},
		
	  
		
  },
  
  
};
</script>

<style scoped="scoped" lang="scss">
	
.filelibrarydetail{
	
	.content{
		display: flex;
		justify-content: center;
		.moddlecon{
			background-color: #FFFFFF;
    		padding: 20px 50px 0px 50px;
			box-sizing: border-box;
			
		}
			
	}
			
	
	
}

</style>
